// Per-tab undo session id. Stored in sessionStorage so it is stable across page
// reloads (the server-side undo stack stays rattachable) but distinct per tab,
// which gives the natural "Ctrl-Z only undoes what I did here" behaviour.

const SESSION_KEY = "compozz-undo-session";

function randomId(): string {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
        return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getUndoSessionId(): string {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
        id = randomId();
        sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
}
